import {Divider} from 'lark';
import React from 'react';
import {refreshQrId, getQrCodeState, cancelQrCode, QR_STATE} from '~/service/qrCode';
import {Response} from '~/service/res';
import QRCodeWrapper from './components/QRCodeWrapper';
import QRCodeScaned from './components/QRScaned';
import QRCodeExplain from './components/QRCodeExplain';
import './index.less';

interface Props {
    // eslint-disable-next-line
    handleLogin: ({qrcodeId}: {qrcodeId: string})=>Promise<any>;
}

interface State {
    qrId: string;
    qrState: (typeof QR_STATE)[keyof typeof QR_STATE];
}


const DELAY = 1000;

/**
 * 当前只在web端使用
 */
class LoginQRCode extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            qrId: '',
            qrState: QR_STATE.UNUSED,
        };
    }

    componentDidMount = () => {
        // effect 获取二维码id
        this.getNewQrId();
    };

    componentWillUnmount = () => {
        // 使后端二维码id失效
        cancelQrCode(this.state.qrId);
        // 组件卸载时清除定时器
        this.stopTimer();
    };

    /** 获取一个新的QrId */
    getNewQrId = () => {
        // effect 获取二维码id
        refreshQrId()
            .then((res: Response<string>) => {
                const qrId = res.data;
                // 设置qrId后渲染会生成图片url设置到img的src上
                this.setState({qrId, qrState: QR_STATE.UNUSED});
                // 设置二维码图片后, 轮询扫码状态
                this.startTimer();
            });
    };

    /** 定时器id */
    timer: NodeJS.Timeout | null = null;

    tryLogin = () => {
        const {handleLogin} = this.props;
        handleLogin({qrcodeId: this.state.qrId});
    };

    /** 轮询扫码状态 */
    startTimer = () => {
        this.stopTimer();
        this.timer = setInterval(() => {
            // 查询扫码状态
            getQrCodeState(this.state.qrId)
                .then(res => {
                    const qrState = res.data;
                    switch (qrState) {
                        case QR_STATE.UNUSED:
                        case QR_STATE.SCANED:
                            // 继续轮询状态
                            break;
                        case QR_STATE.CONFIRMED:
                            // 停止定时器
                            this.stopTimer();
                            // 查询login接口, 获取next进行跳转
                            // setTimeout(this.tryLogin, DELAY);
                            this.tryLogin();
                            // this.tryLogin();
                            break;
                        case QR_STATE.EXPIRED:
                        case QR_STATE.INEXISTENT:
                        case QR_STATE.UNKNOWN:
                            // 停止定时器
                            this.stopTimer();
                            break;
                        default:
                            // eslint-disable-next-line
                            const typeGuard: never = qrState;
                            break;
                    }
                    // 设置qrState更新
                    this.setState({qrState});
                })
                .catch(() => {
                    this.stopTimer();
                });
        }, DELAY);
    };

    stopTimer = () => {
        this.timer && clearInterval(this.timer);
    };

    render = () => {
        const {qrState} = this.state;
        return (
            <div className="login-qr-code-wrapper">
                <Divider />
                {qrState === QR_STATE.SCANED || qrState === QR_STATE.CONFIRMED
                    ? <QRCodeScaned />
                    : <QRCodeWrapper qrId={this.state.qrId} qrState={qrState} handleClick={this.getNewQrId} />
                }
                <QRCodeExplain isScaned={qrState === QR_STATE.SCANED || qrState === QR_STATE.CONFIRMED} />
            </div>
        );
    };
}

export default LoginQRCode;
